import React from 'react'
import PropTypes from 'prop-types'
import {
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from '@chakra-ui/react'
import {ChevronUpIcon, ChevronDownIcon} from '@chakra-ui/icons'
import {useTranslation, Trans} from 'react-i18next'

import {SingleLine} from '../../../utils/address'
import AddressPropTypes from '../../../../utils/propTypes/address'

const BillTo = ({name, phone, email, address}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Popover returnFocusOnClose={false} placement="bottom" closeOnBlur={false}>
      {({isOpen}) => (
        <>
          <PopoverTrigger>
            <Text cursor="pointer">
              <Trans
                t={t}
                i18nKey="header.billToPopoverLabel"
                values={{name}}
                components={{strong: <Text as="span" fontWeight="medium" />}}
              />
              {isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
            </Text>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverBody>
              <Text>{SingleLine(address)}</Text>
              <Text>{phone}</Text>
              <Text>{email}</Text>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}

BillTo.defaultProps = {
  address: null,
}

BillTo.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  address: AddressPropTypes,
}

export default BillTo
